import { MenuOption } from "../../../shared/domain/entities";
import { object, string } from "yup";

const UserDefaultViewOptions: Array<MenuOption> = [
  { value: "offer", label: "Offer View" },
  { value: "rep", label: "Rep View" },
];

const DefaultViewFormSchema = object().shape({
  default_queue_list_order_by: string().required("A default order is required"),
  default_queue_list_sort_by: string().required("A default order is required"),
  default_lists_view: string().required("A default list view is required"),
});

export { DefaultViewFormSchema, UserDefaultViewOptions };
